var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagLuggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53759 2.36568C6.53759 2.21314 6.66785 2.089 6.82791 2.089H8.50532C8.66541 2.089 8.79564 2.21314 8.79564 2.36568V4.01391H9.76338V2.36568C9.76338 1.70458 9.19902 1.16675 8.50532 1.16675H6.82791C6.1342 1.16675 5.56985 1.70458 5.56985 2.36568V4.01391H6.53759V2.36568Z",
    fill: "#AA8768"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5376 3.86301H3.79566C3.17311 3.86301 2.66663 4.34569 2.66663 4.93898V13.8353C2.66663 14.3764 3.08798 14.8253 3.63437 14.9001V15.3723C3.63437 15.6269 3.85101 15.8334 4.11824 15.8334C4.38546 15.8334 4.60211 15.6269 4.60211 15.3723V14.9112H10.7311V15.3723C10.7311 15.627 10.9478 15.8334 11.215 15.8334C11.4822 15.8334 11.6989 15.627 11.6989 15.3723V14.9001C12.2453 14.8253 12.6666 14.3764 12.6666 13.8353V4.93898C12.6666 4.34569 12.1601 3.86301 11.5376 3.86301ZM5.56985 13.2204C5.56985 13.4751 5.35321 13.6816 5.08598 13.6816C4.81875 13.6816 4.60211 13.4751 4.60211 13.2204V5.55382C4.60211 5.29916 4.81875 5.09269 5.08598 5.09269C5.35321 5.09269 5.56985 5.29916 5.56985 5.55382V13.2204ZM10.2473 13.6816C9.98005 13.6816 9.7634 13.4751 9.7634 13.2204V5.55382C9.7634 5.29916 9.98005 5.09269 10.2473 5.09269C10.5145 5.09269 10.7311 5.29916 10.7311 5.55382V13.2204C10.7311 13.4751 10.5145 13.6816 10.2473 13.6816Z",
    fill: "#AA8768"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagLuggage);
export default __webpack_public_path__ + "static/media/BagLuggage.34fd340adbcfe7c25943380484d3c377.svg";
export { ForwardRef as ReactComponent };